// extracted by mini-css-extract-plugin
module.exports = {"icon":"Style_icon__oDsau","icons":"Style_icons__13UWv","touchClass":"Style_touchClass__12C-b","pulse":"Style_pulse__3XlZU"};